var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1781_851",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1781_851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.49935 7.5H16.166C15.791 6.54167 15.2181 5.71875 14.4473 5.03125C13.6764 4.34375 12.791 3.86111 11.791 3.58333L9.49935 7.5ZM7.58268 9.16667L10.916 3.41667C10.7632 3.38889 10.6105 3.36806 10.4577 3.35417C10.3049 3.34028 10.1521 3.33333 9.99935 3.33333C9.08268 3.33333 8.22852 3.50695 7.43685 3.85417C6.64518 4.20139 5.94379 4.66667 5.33268 5.25L7.58268 9.16667ZM3.54102 11.6667H8.08268L4.74935 5.91667C4.3049 6.48611 3.95768 7.11458 3.70768 7.80208C3.45768 8.48958 3.33268 9.22222 3.33268 10C3.33268 10.2917 3.35004 10.5729 3.38477 10.8438C3.41949 11.1146 3.47157 11.3889 3.54102 11.6667ZM8.20768 16.4167L10.4577 12.5H3.83268C4.20768 13.4583 4.7806 14.2813 5.55143 14.9688C6.32227 15.6563 7.20768 16.1389 8.20768 16.4167ZM9.99935 16.6667C10.916 16.6667 11.7702 16.4931 12.5618 16.1458C13.3535 15.7986 14.0549 15.3333 14.666 14.75L12.416 10.8333L9.08268 16.5833C9.23546 16.6111 9.38477 16.6319 9.5306 16.6458C9.67643 16.6597 9.83268 16.6667 9.99935 16.6667ZM15.2493 14.0833C15.6938 13.5139 16.041 12.8854 16.291 12.1979C16.541 11.5104 16.666 10.7778 16.666 10C16.666 9.70833 16.6487 9.42708 16.6139 9.15625C16.5792 8.88542 16.5271 8.61111 16.4577 8.33333H11.916L15.2493 14.0833ZM9.99935 18.3333C8.86046 18.3333 7.78407 18.1146 6.77018 17.6771C5.75629 17.2396 4.87088 16.6424 4.11393 15.8854C3.35699 15.1285 2.75977 14.2431 2.32227 13.2292C1.88477 12.2153 1.66602 11.1389 1.66602 10C1.66602 8.84722 1.88477 7.76736 2.32227 6.76042C2.75977 5.75347 3.35699 4.87153 4.11393 4.11458C4.87088 3.35764 5.75629 2.76042 6.77018 2.32292C7.78407 1.88542 8.86046 1.66667 9.99935 1.66667C11.1521 1.66667 12.232 1.88542 13.2389 2.32292C14.2459 2.76042 15.1278 3.35764 15.8848 4.11458C16.6417 4.87153 17.2389 5.75347 17.6764 6.76042C18.1139 7.76736 18.3327 8.84722 18.3327 10C18.3327 11.1389 18.1139 12.2153 17.6764 13.2292C17.2389 14.2431 16.6417 15.1285 15.8848 15.8854C15.1278 16.6424 14.2459 17.2396 13.2389 17.6771C12.232 18.1146 11.1521 18.3333 9.99935 18.3333Z",
    fill: "#3CB54A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.a145f4085f908dd533a6589418e5415c.svg";
export { ForwardRef as ReactComponent };